import { useMutation } from "@tanstack/react-query";
import { cleanupZeroTotalBills } from "../api/cleanup";

/**
 * React Query mutation за почистване на сметки без касова бележка.
 * Извиква POST /cleanup/zero-total-bills.
 * Операцията може да отнеме няколко секунди — компонентът трябва да покаже loading индикатор.
 */
export const useCleanupZeroTotalBills = () => {
  return useMutation({
    mutationFn: cleanupZeroTotalBills,
  });
};
